import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { BrowserRouter as Router } from "react-router-dom"
import { AppProviders, LibraryProviders } from "web/Providers"
import Counterparties from "web/app/Deals/ViewDeal/Counterparties"
import { NavigationProvider } from "web/contexts"

export default class DealCounterpartiesObjectListController extends Controller {
  static values = {
    basePath: String,
    viewGroup: Object,
    viewId: Number,
    availableViews: Array,
    defaultView: String,
    subjectType: String,
    parentSubjectType: String,
    parentSubjectId: Number,
    breadcrumbs: Array,
    fetchUrl: String,
    itemClickBaseUrl: String,
    addItemUrl: String,
    removeItemUrl: String,
    enableRemoval: Boolean,
    enableEdit: Boolean,
    exportPath: String,
  }

  initialize() {
    global.React = React
  }

  onItemClick(item) {
    window.location.href = `/deals/all/view/${item.deal_id}/${this.itemClickBaseUrlValue}/${item.id}`
  }

  onAdd() {
    window.Turbo.visit(this.addItemUrlValue)
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType={"counterparty"}
              >
                <ErrorBoundary>
                  <Counterparties
                    rootURL={this.basePathValue}
                    availableViews={this.availableViewsValue}
                    defaultView={this.defaultViewValue}
                    subjectType={this.subjectTypeValue}
                    parentSubjectType={this.parentSubjectTypeValue}
                    parentSubjectId={this.parentSubjectIdValue}
                    breadcrumbs={this.breadcrumbsValue}
                    fetchURL={this.fetchUrlValue}
                    handleClick={this.onItemClick.bind(this)}
                    handleAddItem={
                      this.addItemUrlValue && this.onAdd.bind(this)
                    }
                    removeItemUrl={this.removeItemUrlValue}
                    enableRemoval={this.enableRemovalValue}
                    enableEdit={this.enableEditValue}
                    exportPath={this.exportPathValue}
                  />
                </ErrorBoundary>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
